// Shared by the browser and the Worker so both compute a round's score the same way.

export const ROUND_SECONDS = 90;

export interface RoundStats {
  /** Hostile aircraft destroyed, jets included. */
  downed: number;
  /** Hostile jets destroyed; a subset of `downed`. */
  jetsDowned: number;
  friendliesHit: number;
  shellsFired: number;
  /** Hostile aircraft that crossed the screen without being destroyed. */
  escaped: number;
}

export const POINTS = {
  hostile: 100,
  jetBonus: 50,
  friendly: -300,
  shell: -5,
  escaped: -25,
} as const;

export function scoreRound(s: RoundStats): number {
  return (
    s.downed * POINTS.hostile +
    s.jetsDowned * POINTS.jetBonus +
    s.friendliesHit * POINTS.friendly +
    s.shellsFired * POINTS.shell +
    s.escaped * POINTS.escaped
  );
}

export const NAME_PATTERN = /^[A-Za-z0-9 _-]{2,16}$/;

/** Trims and collapses internal whitespace. Returns null when the result is not a valid callsign. */
export function normalizeName(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const name = raw.trim().replace(/\s+/g, " ");
  return NAME_PATTERN.test(name) ? name : null;
}
